import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Stats } from "@/components/Stats";
import { Services } from "@/components/Services";
import { MobileService } from "@/components/MobileService";
import { InsuranceBand } from "@/components/InsuranceBand";
import { CarrierBar } from "@/components/CarrierBar";
import { Reviews } from "@/components/Reviews";
import { HowItWorks } from "@/components/HowItWorks";
import { BeforeAfter } from "@/components/BeforeAfter";
import { QuoteSection } from "@/components/QuoteSection";
import { FaqSection } from "@/components/FaqSection";
import { Team } from "@/components/Team";
import { WarrantySeal } from "@/components/WarrantySeal";
import { Fleet } from "@/components/Fleet";
import { BlogSection } from "@/components/BlogSection";
import { ServiceArea } from "@/components/ServiceArea";
import { ContactSection } from "@/components/ContactSection";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import { ExitIntent } from "@/components/ExitIntent";
import { scrollToId } from "@/utils";

export default function LandingPage() {
  const location = useLocation();

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    if (location.state?.scrollTo) {
      const id = location.state.scrollTo;
      const timer = setTimeout(() => scrollToId(id), 500);
      window.history.replaceState({}, "");
      return () => clearTimeout(timer);
    }
  }, [location.state]);

  return (
    <div className="App bg-[#FAF9F6] text-[#111111]">
      <div className="grain-overlay" />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Stats />
        <Services />
        <MobileService />
        <InsuranceBand />
        <CarrierBar />
        <Reviews />
        <HowItWorks />
        <BeforeAfter />
        <QuoteSection />
        <FaqSection />
        <Team />
        <WarrantySeal />
        <Fleet />
        <BlogSection />
        <ServiceArea />
        <ContactSection />
      </main>
      <Footer />
      <WhatsAppFloat />
      <ExitIntent />
    </div>
  );
}
